import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import SuperTitle from "@/components/common/supertitle/supertitle";
import { ProsConsSection as ProsConsSectionType } from "@/sanity/sanity.types";
interface IProsConsSectionProps {
  data: ProsConsSectionType;
}
const ProsConsSection = t0 => {
  const $ = _c(34);
  const {
    data
  } = t0;
  const {
    eyebrow,
    heading,
    subheading,
    prosCard,
    consCard
  } = data;
  let t1;
  if ($[0] !== eyebrow) {
    t1 = <SuperTitle>{eyebrow}</SuperTitle>;
    $[0] = eyebrow;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== heading) {
    t2 = <h2 className="max-w-[400px] text-[#373A36] lg:text-center">{heading}</h2>;
    $[2] = heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== subheading) {
    t3 = <p className="max-w-[760px] text-[19px] font-normal leading-[29px] text-[#4A4A4A] lg:text-center">{subheading}</p>;
    $[4] = subheading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <GridColumn className="flex flex-col gap-2"><div className="flex flex-col gap-4 self-stretch lg:items-center">{t1}{t2}{t3}</div></GridColumn>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = prosCard?.title;
  let t6;
  if ($[10] !== t5) {
    t6 = <h3 className="mb-4 text-[22px] font-bold leading-[28px] text-[#00698F]">{t5}</h3>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== prosCard) {
    t7 = prosCard?.items?.map((item, index) => <div key={item._key} className={`flex gap-4 py-5 ${index !== (prosCard.items?.length ?? 0) - 1 ? "border-b border-[#E7E7E7]" : ""}`}><div className="mt-1 h-auto w-[2px] shrink-0 bg-[#3BD4AE]" /><div><h4 className="text-[16px] font-bold leading-[21px] text-[#4A4A4A]">{item.title}</h4><p className="mt-2 text-[14px] font-normal leading-[22px] text-[#4A4A4A]">{item.description}</p></div></div>);
    $[12] = prosCard;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <div>{t7}</div>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t8) {
    t9 = <div className="rounded-[8px] border border-[#D9D9D9] bg-white px-8 py-12">{t6}{t8}</div>;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = consCard?.title;
  let t11;
  if ($[19] !== t10) {
    t11 = <h3 className="mb-4 text-[22px] font-bold leading-[28px] text-[#005472]">{t10}</h3>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== consCard) {
    t12 = consCard?.items?.map((item_0, index_0) => <div key={item_0._key} className={`flex gap-4 py-5 ${index_0 !== (consCard.items?.length ?? 0) - 1 ? "border-b border-[#E7E7E7]" : ""}`}><div className="mt-1 h-auto w-[2px] shrink-0 rounded-[2px] bg-[#2E3D55] opacity-[0.4]" /><div><h4 className="text-[#4A4A4A]] text-[16px] font-bold leading-[21px]">{item_0.title}</h4><p className="mt-2 text-[14px] font-normal leading-[22px] text-[#4A4A4A]">{item_0.description}</p></div></div>);
    $[21] = consCard;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <div>{t12}</div>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t11 || $[26] !== t13) {
    t14 = <div className="rounded-[8px] border border-[#D9D9D9] bg-white px-8 py-12">{t11}{t13}</div>;
    $[25] = t11;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14 || $[29] !== t9) {
    t15 = <GridColumn><div className="grid gap-4 lg:grid-cols-2">{t9}{t14}</div></GridColumn>;
    $[28] = t14;
    $[29] = t9;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15 || $[32] !== t4) {
    t16 = <GridRow className="flex flex-col items-start !gap-y-12">{t4}{t15}</GridRow>;
    $[31] = t15;
    $[32] = t4;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
export default ProsConsSection;